import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		mode: 'resource',
		step: 'step1',
		startdate: null,
		enddate: null,
		name: '',
		email: '',
		fromtime: 0,
		totime: 0,
		resource: null,
		resourcehash: null,
		organisation: null,
		organisationhash: null,
		reservation: null,
		customeredithash: null,
		availability: {},
		minreservationtime: null,
	},
	mutations: {
		SET_MODE(state, mode) {
			state.mode = mode
		},
		SET_STEP(state, step) {
			state.step = step
		},
		SET_STARTDATE(state, date) {
			state.startdate = date
		},
		SET_ENDDATE(state, date) {
			state.enddate = date
		},
		SET_NAME(state, name) {
			state.name = name
		},
		SET_MAIL(state, email) {
			state.email = email
		},
		SET_FROMTIME(state, fromtime) {
			state.fromtime = fromtime
		},
		SET_TOTIME(state, totime) {
			state.totime = totime
		},
		SET_RESOURCE(state, resource) {
			state.resource = resource
		},
		SET_RESOURCEHASH(state, resourcehash) {
			state.resourcehash = resourcehash
		},
		SET_ORGANISATIONHASH(state, organisationhash) {
			state.organisationhash = organisationhash
		},
		SET_ORGANISATION(state, organisation) {
			state.organisation = organisation
		},
		SET_RESERVATION(state, reservation) {
			state.reservation = reservation
		},
		SET_CUSTOMEREDITHASH(state, customeredithash) {
			state.customeredithash = customeredithash
		},
		SET_AVAILABILITY(state, availability) {
			state.availability = availability
		},
		SET_MINRESERVATIONTIME(state, date) {
			state.minreservationtime = date
		},
	},
	actions: {},
});
